<template>
   <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>  
        <div class="d-md-flex align-items-center pb-2">
        <h3 class="card-title mb-0">Anggaran</h3>
        <div class="ml-auto">
          <vs-button @click="inputForm"  color="success" type="filled" class="mt-4 mt-md-0">
            <i class="mdi mdi-border-color mr-1"></i> Input Anggaran
          </vs-button>
        </div> 
        </div>
        <hr class="custom-hr" />  
        <JqxGrid ref="myGrid" :autorowheight="true" :autoheight="true"
            :width="width" :theme="'material-green'" :selectionmode="'singlerow'" :ready="ready"
            :pageable="true" :sortable="true" :filterable="true" :showfilterrow="true" :columnsresize="true"
            :source="dataAdapter" :columns="columns" @contextmenu="myGridOnContextMenu()" @rowclick="myGridOnRowClick($event)"
        />
        <JqxMenu ref="myMenu" @itemclick="myMenuOnItemClick($event)"
                 :width="200" :height="88" :mode="'popup'" :autoOpenPopup="false">
            <ul>
                <li>Edit</li>
                <li>Delete</li>
            </ul>
        </JqxMenu>
      </vs-card>
      <vs-popup fullscreen title="CETAK JURNAL" :active.sync="popupPdf">
        <iframe width="100%" height="515" :src="pdfsrc" frameborder="0" />
      </vs-popup>
    </vs-col>
    
   </vs-row>

</template>

<script>
    import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
    import JqxWindow from "jqwidgets-scripts/jqwidgets-vue/vue_jqxwindow.vue";
    import JqxInput from "jqwidgets-scripts/jqwidgets-vue/vue_jqxinput.vue";
    import JqxNumberInput from "jqwidgets-scripts/jqwidgets-vue/vue_jqxnumberinput.vue";
    import JqxButton from "jqwidgets-scripts/jqwidgets-vue/vue_jqxbuttons.vue";
    import JqxMenu from "jqwidgets-scripts/jqwidgets-vue/vue_jqxmenu.vue";
    
  export default {
    components: {
        JqxGrid,
        JqxWindow,
        JqxInput,
        JqxNumberInput,
        JqxButton,
        JqxMenu
    },
    data: function () {
      return {
        // eslint-disable-next-line
        dataAdapter: new jqx.dataAdapter(this.source, {
            formatData: function (data) {
                return  JSON.stringify(data);
            },
            beforeSend: function (jqxhr, settings) { 
                settings.xhrFields = {
                    withCredentials: true
                },
                jqxhr.setRequestHeader("X-XSRF-TOKEN",window.$cookies.get('XSRF-TOKEN'))
            }
        }),
        width: "100%",
        columns: [
          { text: 'Kode', datafield: 'kode'},
          { text: 'Jan', datafield: 'bln_1', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Feb', datafield: 'bln_2', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Mar', datafield: 'bln_3', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Apr', datafield: 'bln_4', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Mei', datafield: 'bln_5', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Jun', datafield: 'bln_6', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Jul', datafield: 'bln_7', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Ags', datafield: 'bln_8', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Sep', datafield: 'bln_9', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Okt', datafield: 'bln_10', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Nov', datafield: 'bln_11', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
          { text: 'Des', datafield: 'bln_12', width: '7%', cellsformat: 'd2', cellsalign: 'right'},
        ],
        selectrow: 0,
        popupPdf: false,
        pdfsrc: ''
      }
    },
    methods: {
        ready: function() {
            this.$refs.myGrid.selectrow(0);
            this.$refs.myGrid.focus();
        },
        inputForm: function(){
            this.$router.push({name : 'anggaraninput'});
        },
        myGridOnContextMenu: function () {
                return false;
        },
        myGridOnRowClick: function (event) {
            if (event.args.rightclick) {
                this.$refs.myGrid.selectrow(event.args.rowindex);
                let scrollTop = window.scrollY;
                let scrollLeft = window.scrollX;
                this.$refs.myMenu.open(parseInt(event.args.originalEvent.clientX) + 5 + scrollLeft, parseInt(event.args.originalEvent.clientY) + 5 + scrollTop);
                return false;
            }
        },
        myMenuOnItemClick: function (event) {
            let args = event.args;
            let rowindex = this.$refs.myGrid.getselectedrowindex();
            if (args.innerHTML == 'Edit') {
                this.editrow = rowindex;
                let dataRecord = this.$refs.myGrid.getrowdata(this.editrow)
                let rowid = dataRecord.id
                console.log(dataRecord);
                this.$router.push({name : 'anggaranedit', params: { ref: rowid }});
            }
            else if (args.innerHTML == 'Delete'){
                this.editrow = rowindex;
                let dataId = this.$refs.myGrid.getrowid(rowindex)
                let dataRecord = this.$refs.myGrid.getrowdata(this.editrow)
                let rowid = dataRecord.id
                if(confirm("Yakin menghapus data?")){
                    this.$http.delete(`/api/anggaran/${rowid}`).then(resp => {
                        this.$refs.myGrid.deleterow(dataId);
                        this.$vs.notify({title:'BERHASIL..',text:'Data berhasil dihapus..',color:'danger'})
                    }).catch(error => {
                        console.log(error);
                    })
                }
            }
        }
    },
    beforeCreate: function () {
      this.source = {
        datafields: [
          { name: 'id', type: 'string'},
          { name: 'kode', type: 'string'},
          { name: 'bln_1', type: 'number'},
          { name: 'bln_2', type: 'number'},
          { name: 'bln_3', type: 'number'},
          { name: 'bln_4', type: 'number'},
          { name: 'bln_5', type: 'number'},
          { name: 'bln_6', type: 'number'},
          { name: 'bln_7', type: 'number'},
          { name: 'bln_8', type: 'number'},
          { name: 'bln_9', type: 'number'},
          { name: 'bln_10', type: 'number'},
          { name: 'bln_11', type: 'number'},
          { name: 'bln_12', type: 'number'},
        ],
        datatype: 'json',
        id: 'referensi',
        url: this.$urlbackend+'/api/anggaranlist',
        type: 'post',
        deleterow: function (rowid, commit) {
            commit(true);
        }
      }
      this.editrow = -1;
    },
    created: function(){
        var self = this
        let processdata=function (data) {
            data.THN = window.$cookies.get('THN')
            data.jenis = self.jenisJurnal
            data.bpbmode = self.bpbmode
        }
        this.source.processdata = processdata
    }, 
    mounted: function () {
        document.addEventListener('contextmenu', event => event.preventDefault());
    },
    watch: {
        popupPdf: function(){
            if (this.popupPdf == false)
                this.pdfsrc = 'about:blank'
            else
                this.pdfsrc = this.pdfsrc + "#zoom=100"
        }
    }
  }
</script>

<style src='@/assets/styles/jqwidgets/jqx.base.css'></style>


